import { AxisSwitcher, Image, SpacerWrapper } from '@ahmdigital/ui';

import getImageAttributes from '../../../../../../../cms/utils/get-image-attributes';
import getLinkFromSanityTerm from '../../../../../../../utils/get-link-from-sanity-term';
import styles from './styles.module.sass';
import SummaryDescription from '../summary-description';

type SummaryWithImageItemProps = {
  refersToItemExplainedTerm: {};
  reverseColumn?: boolean;
};

const SummaryWithImageItem = ({ refersToItemExplainedTerm, reverseColumn = false }: SummaryWithImageItemProps) => {
  // @ts-expect-error - Automatic, Please fix when editing this file
  const { imageObject, mediaObject, slogan } = refersToItemExplainedTerm;
  const summaryImage = getImageAttributes({ height: 240, imageObject });
  const ctaObject = getLinkFromSanityTerm(refersToItemExplainedTerm) || undefined;

  return (
    <SpacerWrapper variant="paddingTopSpacer2">
      <AxisSwitcher
        // @ts-expect-error - Automatic, Please fix when editing this file
        key={refersToItemExplainedTerm.id}
        reverseColumnPresentationOrder={reverseColumn}
        limit={2}
        threshold="35rem"
        space="1.5rem"
      >
        <SummaryDescription callToAction={ctaObject} mediaObject={mediaObject} slogan={slogan} />
        {summaryImage && (
          <div className={styles.imageWrapper}>
            <Image {...summaryImage} className={styles.image} />
          </div>
        )}
      </AxisSwitcher>
    </SpacerWrapper>
  );
};

export default SummaryWithImageItem;
